// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__IM92T","title":"Hero_title__XlKUl","text":"Hero_text__eW1HA"};